import User from "./User";

const meSchema = {
  ...User,
  $id: "/me",
  title: "Me",
};

export default meSchema;
